export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9723.d7a4f474.jpg";